// Since we're not using Supabase anymore, this hook just manages online status
import { useState, useEffect, useCallback } from 'react';

export function useSync() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [error, setError] = useState<string | null>(null);

  const handleOnline = useCallback(() => {
    setIsOnline(true);
    setError(null);
  }, []);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
    setError('You are currently offline. Changes are saved locally.');
  }, []);

  useEffect(() => {
    setIsOnline(navigator.onLine);
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return {
    isOnline,
    isSyncing: false,
    lastSynced: null,
    error
  };
}